export async function playSound(url: string) {
  try {
    const audio = new Audio(url);
    await audio.play();
  } catch (err) {
    // ignore NotAllowedError: permission denied
  }
}
